// 화면 검토용 더미 데이터입니다. 실제 회원 정보나 연습 결과와 연결하지 않습니다.
export const nickname = '귀염뽀짝한 고슴도치_47052';

export const reflections = [
    { id: 'r3', date: '2026.09.15', title: '변하고 싶지만 두려운 마음', type: '양면 반영', count: 5, rank: 8, quote: '달라지고 싶은데, 또 실패할까 봐 시작이 어려워요.', answer: '실패가 두렵지만, 지금과는 다르게 살아보고 싶은 마음도 있으시군요.', feedback: '변화에 대한 바람과 망설임을 함께 담았어요. 다음에는 내담자가 말한 변화의 이유를 조금 더 구체적으로 반영해보세요.' },
    { id: 'r2', date: '2026.09.12', title: '인정받고 싶은 마음', type: '감정 반영', count: 4, rank: 12, quote: '열심히 했는데 아무도 알아주지 않아요.', answer: '노력한 만큼 인정받지 못해서 서운하셨겠어요.', feedback: '서운한 감정을 정확히 짚었어요. 인정받고 싶은 바람까지 담으면 더 깊은 반영이 될 수 있어요.' },
    { id: 'r1', date: '2026.09.09', title: '관계에서 한 걸음 물러나기', type: '의미 반영', count: 3, rank: 10, quote: '요즘은 사람들을 만나고 나면 혼자 있고 싶어요.', answer: '관계도 소중하지만, 나를 돌볼 시간도 필요하셨군요.', feedback: '혼자 있는 시간을 회복의 의미로 연결했어요. 단정하기보다 내담자가 그 의미에 동의하는지 확인해보세요.' },
];

export const cases = [
    { id: 'lee', name: '이지윤', concern: '직장 스트레스 · 자기비판', sessions: [
        { number: 2, date: '2026.09.15', duration: 18, dialogue: [
            ['내담자', '지난번 이야기하고 나서 쉬는 시간을 조금 가져봤어요.'], ['상담자', '바쁜 중에도 자신을 위한 시간을 만들어보셨네요.'],
            ['내담자', '그래도 쉬면 뒤처지는 것 같아요.'], ['상담자', '쉬고 싶은 마음과 잘 해내고 싶은 마음이 함께 있군요.'],
        ], strength: '휴식을 시도한 작은 변화를 인정하고 양가감정을 반영했어요.', growth: '휴식이 실제로 어떤 영향을 주었는지 열린 질문으로 탐색해보세요.', next: '“잠깐 쉬어보니 어떤 점이 달랐나요?”라고 물어보세요.' },
        { number: 1, date: '2026.09.10', duration: 15, dialogue: [
            ['내담자', '회사에서 작은 실수만 해도 제가 부족한 사람 같아요.'], ['상담자', '실수 하나가 나 자신에 대한 평가로 이어지는군요.'],
            ['내담자', '네, 잘하고 싶은데 늘 긴장해요.'], ['상담자', '잘하고 싶은 만큼 긴장도 크셨겠어요.'],
        ], strength: '자기비판 뒤의 잘하고 싶은 마음을 알아주었어요.', growth: '감정을 반영한 뒤 내담자가 더 이야기할 여유를 주세요.', next: '반영 후 잠시 기다리며 내담자의 반응을 살펴보세요.' },
    ] },
    { id: 'jung', name: '정서연', concern: '대인관계 · 감정 표현', sessions: [
        { number: 1, date: '2026.09.13', duration: 20, dialogue: [
            ['내담자', '친구에게 서운하다고 말하면 멀어질까 봐 걱정돼요.'], ['상담자', '마음은 전하고 싶지만 관계를 잃을까 두려우시군요.'],
            ['내담자', '맞아요. 그냥 참게 돼요.'], ['상담자', '그동안 관계를 지키려고 마음을 많이 눌러오셨네요.'],
        ], strength: '감정 표현을 망설이는 이유를 관계의 맥락에서 이해했어요.', growth: '참는 것 외에 시도해본 방법이 있는지 탐색해보세요.', next: '“마음을 조금이라도 전할 수 있었던 때가 있나요?”라고 물어보세요.' },
    ] },
];
